<template>
  <!-- 使用 -->
  <van-popup
    v-model="showPopup"
    position="center"
    closeable
    round
    :style="{ width: '660px', height: '600px' }"
    @close="closePopup"
  >
    <div class="ach-card-list-component">
      <!-- 加载中状态 -->
      <div v-if="!dataLoaded" class="loading-state">
        <!-- 使用通用toast的颜色 黑色 -->
        <van-loading type="spinner" color="#333" />
        <p>{{ $t("common.loadingCommonText") || "加载中..." }}</p>
      </div>

      <!-- 银行卡列表 -->
      <div
        v-if="dataLoaded && cardList.length > 0 && !showAchComponent"
        class="ach-card-list-component"
      >
        <div class="ach-card-list">
          <div
            v-for="card in cardList"
            :key="card.id"
            class="ach-card-item"
            :class="{ selected: selectedCardId === card.bankAccountToken }"
            @click="selectCard(card)"
          >
            <div class="card-info">
              <div class="card-number">
                Account number: *****{{ card.bankSummary }}
              </div>
              <div class="account-holder">
                Holder name: {{ card.ownerName }}
              </div>
              <!-- <div class="account-type">{{ card.bankAccountToken }}</div> -->
            </div>
            <div class="card-actions" v-if="showActions">
              <van-icon name="delete" @click.stop="confirmDelete(card)" />
            </div>
          </div>
        </div>

        <!-- 添加新账户按钮 -->
        <div class="ach-card-list">
          <div
            class="ach-card-item add-card-item"
            :class="{ selected: selectedCardId === 'new-card' }"
            @click="addNewCard"
          >
            <div class="add-card-content">
              <van-icon name="plus" size="24" color="#999" />
              <div class="add-card-text">{{ $t("common.addNewCard") }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 添加新卡界面 - 仅当数据加载完且卡列表为空，或显式切换到添加卡模式时显示 -->
      <div v-if="showAchComponent && dataLoaded">
        <AchPaymentComponent
          :environment="environment"
          :clientKey="clientKey"
          @payment-completed="handlePaymentCompleted"
          @payment-error="handlePaymentError"
          @payment-submit="handlePaymentSubmit"
          @payment-change="handlePaymentChange"
          ref="achPaymentComponent"
        />
        <!-- 返回卡支付按钮 -->
        <div class="goBackBtnBox" v-if="cardList.length > 0">
          <div class="goBackBtn" @click="goBack()">
            {{ $t("common.returnCardList") }}
          </div>
        </div>
      </div>

      <!-- pay按钮 - 仅在数据加载完成后显示 -->
      <div class="payBtn-group" v-if="dataLoaded">
        <div
          class="payBtn"
          :class="{
            disabled: !canPay
          }"
          @click="goPay"
          id=""
        >
        {{ $t("common.confirm") }}
        </div>
      </div>

      <!-- 删除确认弹窗 -->
      <van-dialog
        v-model="showDeleteDialog"
        :title="$t('common.deleteCardConfirmTitle')"
        show-cancel-button
        :cancel-button-text="$t('common.deleteCardCancel')"
        :show-confirm-button="true"
        :confirm-button-text="$t('common.deleteCardConfirm')"
        confirm-button-color="#ffaa0a"
        @cancel="handleCancel"
        @confirm="handleDelete"
      >
        <p class="delete-message">{{ $t("common.deleteCardConfirmText") }}</p>
      </van-dialog>
    </div>
  </van-popup>
</template>

<script>
import { Toast } from "vant";
import AchPaymentComponent from "@/components/subscription/AchPaymentComponent.vue";
import api from "@/api/api";
import utils from "@/utils/index";
import indexMixin from "../../mixins/index";
export default {
  name: "AchCardListComponent",
  mixins: [indexMixin],
  components: {
    AchPaymentComponent
  },
  props: {
    // 银行卡列表数据
    cardList: {
      type: Array,
      default: () => []
    },
    // 是否显示popup
    showPopup: {
      type: Boolean,
      default: true
    },
    // 是否显示操作按钮（删除）
    showActions: {
      type: Boolean,
      default: true
    },
    // 是否显示添加新账户按钮
    showAddButton: {
      type: Boolean,
      default: true
    },
    // 初始选中的卡ID
    initialSelectedCardId: {
      type: [String, Number],
      default: null
    },
    // 客户端key
    clientKey: {
      type: String,
      default: ""
    },
    // 环境
    environment: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedCardId: null,
      bankAccountToken: null,
      cardToDelete: null,
      showDeleteDialog: false,
      showAchComponent: false,
      isFormValid: false,
      dataLoaded: false,
      fpxPaymentMethod: {}
    };
  },
  computed: {
    // 计算是否能够支付的条件
    canPay() {
      const hasSelectedCard =
        this.selectedCardId && this.selectedCardId !== "new-card";
      const hasValidForm = this.showAchComponent && this.isFormValid;

      // 记录状态用于调试
      console.log("计算canPay:", {
        hasSelectedCard,
        hasValidForm,
        showAchComponent: this.showAchComponent,
        isFormValid: this.isFormValid,
        selectedCardId: this.selectedCardId
      });

      // 满足任一条件即可支付：
      // 1. 选择了已有卡片
      // 2. 展示表单并且表单有效
      return hasSelectedCard || hasValidForm;
    }
  },
  watch: {
    cardList: {
      handler(newValue) {
        console.log(newValue, "====cardList");
        this.dataLoaded = true;

        // 只有当接口请求返回的cardList确实为空数组时，才展示Adyen组件
        if (Array.isArray(newValue) && newValue.length === 0) {
          this.showAchComponent = true;
        } else if (Array.isArray(newValue) && newValue.length > 0) {
          this.showAchComponent = false;
          // 如果有卡列表数据，默认选中第一张卡
          this.selectedCardId = newValue[0].bankAccountToken;
          this.bankAccountToken = newValue[0].bankAccountToken;
          this.$emit("card-selected", newValue[0]);
        }
      }
    },
    initialSelectedCardId: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          console.log(newValue, "=22222===newValue");
          this.selectedCardId = newValue;
          this.bankAccountToken = newValue;
        }
      }
    }
  },
  methods: {
    /**
     * 选择银行卡
     */
    selectCard(card) {
      this.selectedCardId = card.bankAccountToken;
      this.bankAccountToken = card.bankAccountToken;
      this.reportLog({
        eventId: "SELECTCARD_PC",
        msg: ""
      });
      this.$emit("card-selected", card);
    },

    /**
     * 确认删除银行卡
     */
    confirmDelete(card) {
      this.cardToDelete = card;
      this.showDeleteDialog = true;
      this.bankAccountToken = card.bankAccountToken;
      this.reportLog({
        eventId: "DELETECARD_PC",
        msg: ""
      });
    },

    /**
     * 删除银行卡
     */
    handleDelete() {
      this.reportLog({
        eventId: "DELETECARD_SHOW_PC",
        msg: ""
      });
      if (!this.cardToDelete) return;
      // 调用删除银行卡接口confirmDelete
      const checkoutToken = utils.getUrlSearch("checkoutToken");
      const businessCode = utils.getUrlSearch("businessCode");
      const merchantPayNo = utils.getUrlSearch("merchantPayNo");
      api.apiMethod.deleteCard
        .post(
          {
            businessCode: businessCode,
            merchantPayNo: merchantPayNo
          },
          {
            bankAccountToken: this.bankAccountToken,
            checkoutToken: checkoutToken
          }
        )
        .then(res => {
          console.log(res, "====res");
          if (res.data.code === 10000) {
            // subCode 200 删除成功
            if (res.data.subCode === "200") {
              Toast.success({
                message: this.$t("common.deleteCardSuccess"),
                className: "custom-toast-success"
              });
              this.bankAccountToken = null;
              this.$emit("delete-card", this.cardToDelete);
              this.reportLog({
                eventId: "DELETECARD_COMFIRM_PC"
              });
            } else {
              Toast.fail({
                message: res.data.subMsg,
                className: "custom-toast-error"
              });
            }
          } else {
            Toast.fail({
              message: this.$t("common.deleteCardError"),
              className: "custom-toast-error"
            });
            this.reportLog({
              eventId: "DELETECARD_ERROR_PC"
            });
          }
        });
    },
    /**
     * 取消删除
     */
    handleCancel() {
      this.reportLog({
        eventId: "DELETECARD_CANCEL_PC"
      });
      this.showDeleteDialog = false;
    },
    /**
     * 添加新卡
     */
    addNewCard() {
      this.reportLog({
        eventId: "SELECTNEWCARD_PC"
      });
      this.selectedCardId = null;
      this.showAchComponent = true;
    },

    handlePaymentCompleted(result) {
      console.log("Payment completed:", result);
      // 这里可以添加支付完成后的逻辑，如跳转到成功页面
      Toast.success({
        message: "支付成功",
        className: "custom-toast-success"
      });
      this.showAchComponent = false;
      this.reportLog({
        eventId: "PAYSUCCESS_PC"
      });
    },
    handlePaymentError(error) {
      console.error("Payment error:", error);
      Toast.fail({
        message: error.message || "支付处理出错，请稍后再试",
        className: "custom-toast-error"
      });
    },
    handlePaymentSubmit(state) {
      console.log("Payment submitted:", state);
      // 这里可以添加支付提交前的逻辑
    },
    handlePaymentChange(state) {
      console.log("Payment data changed:", state);

      // 明确记录表单的有效性状态
      const wasValid = this.isFormValid;
      this.isFormValid = state.isValid || false;

      // 如果状态从无效变为有效，记录日志
      if (!wasValid && this.isFormValid) {
        console.log("表单状态从无效变为有效");
        this.reportLog({
          eventId: "FORM_VALID_PC",
          payCode: "ACH"
        });
      }
      this.fpxPaymentMethod = state.data.paymentMethod;
      // 发送状态变更事件给父组件
      this.$emit("payment-change", {
        isValid: this.isFormValid,
        data: state.data
      });
    },
    closePopup() {
      this.$emit("close-popup");
    },
    goBack() {
      this.showAchComponent = false;
      // 选中第一个
      if (this.cardList.length > 0) {
        this.selectedCardId = this.cardList[0].bankAccountToken;
        this.bankAccountToken = this.cardList[0].bankAccountToken;
      }
    },
    goPay() {
      console.log("调用goPay方法，当前canPay状态:", this.canPay);
      console.log(
        "isFormValid:",
        this.isFormValid,
        "selectedCardId:",
        this.selectedCardId,
        "bankAccountToken:",
        this.bankAccountToken
      );

      if (!this.canPay) {
        console.log("按钮处于禁用状态，不执行支付操作");
        return;
      }

      this.reportLog({
        eventId: "PAY_PC",
        payCode: "ACH"
      });

      // 如果是选卡后去支付
      if (this.selectedCardId && this.bankAccountToken) {
        console.log(
          "使用已有卡支付，卡号:",
          this.selectedCardId,
          "银行账户Token:",
          this.bankAccountToken
        );
        this.proceedToPayment({
          type: "cardPayment",
          bankAccountToken: this.bankAccountToken
        });
      } else if (this.isFormValid) {
        // 使用新卡支付，需要先进行 giact 验证
        console.log("使用新卡支付，开始 giact 验证");
        this.verifyAndPay();
      } else {
        console.log("支付条件不满足，无法发起支付");
        Toast.fail({
          message: "请选择银行卡或填写完整表单",
          className: "custom-toast-warning"
        });
      }
    },

    /**
     * giact 验证并支付
     */
    async verifyAndPay() {
      try {
        const merchantPayNo = utils.getUrlSearch("merchantStageNo");
        const checkoutToken = utils.getUrlSearch("checkoutToken");
        const payProduct = "81";
        const extendParam = utils.buildAccountVerifyExtendParam(
          this.fpxPaymentMethod
        );

        // 显示加载提示
        const loadingToast = Toast.loading({
          message: "验证中...",
          forbidClick: true,
          duration: 0,
          className: "custom-toast-loading"
        });

        console.log("发起 giact 验证请求");
        const res = await api.apiMethod.verifyGiact.post(
          {
            merchantPayNo: merchantPayNo,
            payProduct: payProduct,
            extendParam: extendParam
          },
          {
            checkoutToken: checkoutToken
          }
        );

        // 关闭加载提示
        loadingToast.clear();

        console.log("giact 验证结果:", res);

        // 检查验证结果
        if (
          res.data &&
          res.data.data &&
          res.data.data.verificationResult === true
        ) {
          console.log("giact 验证成功，继续支付");
          this.reportLog({
            eventId: "GIACT_VERIFY_SUCCESS_PC_subscription",
            payCode: "ACH"
          });

          this.proceedToPayment({
            type: "newCardPayment"
          });
        } else {
          console.log("giact 验证失败");
          Toast.fail({
            message: this.$t("common.giactVerifyFailed") || "giact验证失败",
            className: "custom-toast-error"
          });
          this.reportLog({
            eventId: "GIACT_VERIFY_FAILED_PC_subscription",
            payCode: "ACH",
            msg: "verificationResult is not true"
          });
        }
      } catch (error) {
        console.error("giact 验证请求失败:", error);
        Toast.fail({
          message:
            this.$t("common.giactVerifyFailed") || "验证失败，请稍后重试",
          className: "custom-toast-error"
        });
        this.reportLog({
          eventId: "GIACT_VERIFY_ERROR_PC_subscription",
          payCode: "ACH",
          msg: error.message || "API request failed"
        });
      }
    },

    /**
     * 执行支付操作
     */
    proceedToPayment(paymentData) {
      console.log("执行支付操作:", paymentData);
      this.$emit("close-popup");
      this.$emit("goPay", paymentData);
    }
  },
  mounted() {
    // 初始不展示Adyen组件，等待cardList数据返回
    this.showAchComponent = false;
  }
};
</script>

<style lang="less">
/* 移除了scoped属性，使样式可以影响到子组件 */
.ach-card-list-component {
  padding: 30px;

  .loading-state {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 300px;

    p {
      margin-top: 15px;
      color: #666;
      font-size: 14px;
    }
  }

  .ach-card-list {
    .ach-card-item {
      margin-bottom: 16px;
      padding: 12px;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      position: relative;
      overflow: hidden;
      transition: all 0.3s;
      border: 2px solid transparent;
      &.selected {
        border: 2px solid #ffaa0a;
      }

      &:active {
        background-color: #f5f5f5;
      }

      &.add-card-item {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 80px;
        border: 1px dashed #999;
        background-color: #fff;
        cursor: pointer;

        .add-card-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 100%;

          .add-card-text {
            margin-left: 8px;
            color: #999;
            font-size: 14px;
            font-weight: 500;
          }
        }

        &:active {
          background-color: rgba(255, 170, 10, 0.1);
        }

        &.selected {
          border: 2px solid #ffaa0a;
          background-color: rgba(255, 170, 10, 0.1);
        }
      }

      .card-info {
        margin-top: 10px;
        padding: 0 8px;

        .account-holder,
        .card-number {
          font-size: 14px;
          color: #333;
          margin-bottom: 10px;
        }

        .account-type {
          font-size: 12px;
          color: #666;
        }
      }

      .card-actions {
        position: absolute;
        top: 12px;
        right: 12px;

        .van-icon {
          font-size: 18px;
          color: #999;
          padding: 5px;

          &:active {
            color: #ffaa0a;
          }
        }
      }
    }
  }

  .delete-message {
    padding: 16px;
    text-align: center;
  }
}
.ach-card-list-component .payBtn-group {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.payBtn {
  width: 220px;
  height: 40px;
  background: #ffaa0a;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(255, 170, 10, 0.3);

  &:hover:not(.disabled) {
    background: #ff9900;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(255, 170, 10, 0.4);
  }

  &:active:not(.disabled) {
    transform: translateY(1px);
    box-shadow: 0 1px 3px rgba(255, 170, 10, 0.3);
  }

  &.disabled {
    background: #ccc;
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.7;
  }
}
.goBackBtnBox {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 0 10px;
  .goBackBtn {
    height: 40px;
    background: #ffaa0a;
    width: 220px;
    cursor: pointer;
    color: #fff;
    line-height: 40px;
    text-align: center;
    font-size: 100%;
    border-radius: 5px;
  }
}

/* 自定义 Toast 样式 */
.van-toast {
  width: auto !important;
  max-width: 80vw !important;
  min-width: 120px !important;
  padding: 12px 20px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  text-align: center !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* 针对不同类型的 Toast 调整样式 */
.custom-toast-success {
  .van-toast {
    background-color: #52c41a !important;
    color: #ffffff !important;
  }
}

.custom-toast-error {
  .van-toast {
    background-color: #ff4d4f !important;
    color: #ffffff !important;
  }
}

.custom-toast-warning {
  .van-toast {
    background-color: #faad14 !important;
    color: #ffffff !important;
  }
}

.custom-toast-loading {
  .van-toast {
    background-color: rgba(0, 0, 0, 0.7) !important;
    color: #ffffff !important;
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .van-toast {
    max-width: 90vw !important;
    padding: 10px 16px !important;
    font-size: 13px !important;
  }
}
</style>
